/**
 * 加工规则模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取加工规则列表
export const processingList = (params) => {
  return req.get('/hosp/processing/list', params);
}

// 新增加工规则
export const processingAdd = (params) => {
  return req.post('/hosp/processing', params);
}

// 修改加工规则
export const processingEdit = (params) => {
  return req.put('/hosp/processing', params);
}

// 获取加工规则详情
export const processingInfo = (processingRulesId) => {
  return req.get(`/hosp/processing/${processingRulesId}`);
}

// 获取加工规则列表
export const processingPrice = (params) => {
  return req.get('/hosp/processing/getPrice', params);
}

// 删除加工规则
export const processingDelete = (id) => {
  return req.delete(`/hosp/processing/${id}`,);
}